import { render, staticRenderFns } from "./ParametrosPerfil.vue?vue&type=template&id=75fb3c68&scoped=true"
import script from "./ParametrosPerfil.vue?vue&type=script&lang=js"
export * from "./ParametrosPerfil.vue?vue&type=script&lang=js"
import style0 from "./ParametrosPerfil.vue?vue&type=style&index=0&id=75fb3c68&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb3c68",
  null
  
)

export default component.exports